import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';

const VARIANTS = {
  staff: {
    badge: 'دخول فريق العمل',
    title: 'منصّة العمليات',
    tagline: 'إدارة المهام والمشاريع والعملاء في مكان واحد',
    points: ['متابعة المهام والمسارات', 'تقارير الأداء والتقارير المالية', 'تفريغ الصوتيات والفيديوهات'],
    submit: 'تسجيل الدخول',
    altText: 'هل أنت عميل؟',
    altLabel: 'الدخول إلى بوابة العملاء',
    altTo: '/support',
  },
  client: {
    badge: 'بوابة العملاء',
    title: 'بوابة العملاء',
    tagline: 'تابع تذاكرك ومشاريعك وراسل فريق العمل مباشرة',
    points: ['فتح التذاكر ومتابعة حالتها', 'إرفاق الملفات ومشاركة روابط الدرايف', 'التواصل المباشر مع فريق العمل'],
    submit: 'الدخول إلى البوابة',
    altText: 'من فريق العمل؟',
    altLabel: 'دخول فريق العمل',
    altTo: '/login',
  },
};

export default function Login({ variant = 'staff' }) {
  const { login } = useAuth();
  const v = VARIANTS[variant] || VARIANTS.staff;

  const [email, setEmail] = useState(localStorage.getItem('lastEmail') || '');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password, remember);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className={`auth-page ${variant === 'client' ? 'auth-client' : ''}`}>
      <div className="auth-shell">
        <aside className="auth-brand">
          <Logo variant="white" height={112} className="auth-brand-logo" />
          <h1>{v.title}</h1>
          <p>{v.tagline}</p>
          <ul>
            {v.points.map(p => <li key={p}>{p}</li>)}
          </ul>
        </aside>

        <section className="auth-panel">
          <div className="auth-badge">{v.badge}</div>
          <h2>مرحباً بعودتك</h2>
          <p className="auth-sub">سجّل الدخول للمتابعة</p>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label className="form-label" htmlFor="login-email">البريد الإلكتروني</label>
              <input id="login-email" className="form-input" type="text" autoComplete="username" inputMode="email"
                placeholder="name@example.com" value={email}
                onChange={e => setEmail(e.target.value.trim())} required autoFocus />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="login-password">كلمة المرور</label>
              <div className="auth-password">
                <input id="login-password" className="form-input" type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password" placeholder="••••••••" value={password}
                  onChange={e => setPassword(e.target.value)} required />
                <button type="button" className="auth-eye" onClick={() => setShowPassword(s => !s)}
                  title={showPassword ? 'إخفاء' : 'إظهار'} aria-label={showPassword ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'}>
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <div className="auth-row">
              <label className="auth-remember">
                <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} />
                <span>حفظ الدخول على هذا المتصفح</span>
              </label>
              <Link className="auth-link" to={variant === 'client' ? '/forgot-password?portal=client' : '/forgot-password'}>نسيت كلمة المرور؟</Link>
            </div>

            <button className="btn btn-primary auth-submit" disabled={loading}>
              {loading ? 'جاري الدخول...' : v.submit}
            </button>
          </form>

          <div className="auth-alt">
            {v.altText} <Link className="auth-link" to={v.altTo}>{v.altLabel}</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
